import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class FormulaElement {
  constructor(id, type) {
    _defineProperty(this, "_id", void 0);
    _defineProperty(this, "_type", void 0);
    _defineProperty(this, "_group", void 0);
    this._id = id;
    this._type = type;
  }
  get id() {
    return this._id;
  }
  get type() {
    return this._type;
  }
  withNewType(type) {
    return new FormulaElement(this.id, type);
  }
  get group() {
    return this._group;
  }
  set group(value) {
    this._group = value;
  }
}
//# sourceMappingURL=FormulaElement.js.map
